import { Component, Inject, Input, OnInit, PLATFORM_ID } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Subscription } from 'rxjs/internal/Subscription';
import { ApiService } from '../../services/apiService.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { ClevertapService } from 'src/app/shared/services/clevertap/clevertap.service';
import { isPlatformBrowser } from '@angular/common';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-product-review',
  templateUrl: './product-review.component.html',
  styleUrls: ['./product-review.component.scss']
})
export class ProductReviewComponent implements OnInit {
  environment1 = environment.s3bucket.url;
  heartUrls = {
    empty: '../../../assets/images/Star-unfilled.svg',
    half: '../../../assets/images/Star-unfilled.svg',
    full: '../../../assets/images/Star-filled.svg',
  };
  @Input() data: any;
  customerRatingForm: any;
  isShowThankyouPage: boolean = false;
  sub: Subscription = new Subscription;
  overall: any;
  performance: any;
  safety: any;
  comfort: any;
  design: any;
  ratingPresent: any;
  productId: any;
  imageURL: any;
  fileToUpload: any = '';
  constructor(private toastrService: ToastrService, private fb: FormBuilder,
     private apiService: ApiService,    private router: Router,
     @Inject(PLATFORM_ID) private platformId: Object,
     private cleverService: ClevertapService,

     private modalService: NgbModal) {
    this.customerRatingForm = this.fb.group({
      titleAndReview: ["", Validators.required],
      writeReview: [""],
    })
  }

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      try {
        this.cleverService.onPageView("Product Review");
      } catch { }
    }
    this.productId = this.data.productId;

    if (this.data.ratingPresent) {
      this.overall = this.data.overall.rating ? this.data.overall.rating : [];
      this.performance = this.data.performance.rating ? this.data.performance.rating : [];
      this.safety = this.data.safety.rating ? this.data.safety.rating : [];
      this.comfort = this.data.comfort.rating ? this.data.comfort.rating : [];
      this.design = this.data.design.rating ? this.data.design.rating : [];
      this.customerRatingForm.controls['titleAndReview'].setValue(this.data.title)
      this.customerRatingForm.controls['writeReview'].setValue(this.data.description)
      // this.fileToUpload = 'https://buytrucknbus-st-tatamotors-com/buytrucknbus-st-tatamotors-com/cv/' + this.data.image
      // this.imageURL = 'https://buytrucknbus-st-tatamotors-com/buytrucknbus-st-tatamotors-com/cv/' + this.data.image
      this.fileToUpload = this.data.image
      this.imageURL = this.fileToUpload
    }
    else {
      this.overall = 0;
      this.performance = 0;
      this.safety = 0;
      this.comfort = 0;
      this.design = 0;
    }
  }
  notAllowSpace(event: any) {
    if (event.target.selectionStart === 0 && event.which === 32) {
      event.preventDefault();
    }
  }
  Close() {
    this.modalService.dismissAll();
    // this.router.navigate(['/account/booking'])

  }

  writeReview() {
    try {
      if (this.ratingPresent) {
        this.updateProductRating()
      }
      else {
        if (!this.overall || this.overall == 0) {
          this.toastrService.warning('Please select overall rating.');
          return;
        }
        if (this.customerRatingForm.invalid) {
          this.toastrService.warning('Please fill all details.');
          return;
        }
        let formData = new FormData
        formData.append("action_type", "product")
        formData.append("product_id", this.productId)
        formData.append("rating_data", JSON.stringify([{ 'type': 'safety', 'rating': this.safety }, { 'type': 'performance', 'rating': this.performance }, { 'type': 'design', 'rating': this.design }, { 'type': 'comfort', 'rating': this.design }, { 'type': 'overall', 'rating': this.overall }]))
        formData.append("organization_id", "")
        formData.append("title", this.customerRatingForm.value.titleAndReview)
        formData.append("description", this.customerRatingForm.value.writeReview)
        formData.append("image", this.fileToUpload)
        formData.append("video", "")
        this.sub.add(this.apiService.createReview(formData).subscribe({
          next: (res: any) => {
            if (res.success) {
              this.isShowThankyouPage = true
              this.router.navigate(['/account/booking'])

            }
            else {
              this.toastrService.warning(res.data.msg);
            }

          },
          error: (error) => {
            this.toastrService.warning(error);
          }
        }))
      }
    }
    catch(res) {
      this.toastrService.warning(res.data.msg)
    }
  }
  updateProductRating() {
    if (!this.overall || this.overall < 1) {
      this.toastrService.warning('Please select overall rating.');
      return;
    }
    if (this.customerRatingForm.invalid) {
      this.toastrService.warning('Please fill all details.');
      return;
    }
    let formData = new FormData
    formData.append("action_type", "product")
    formData.append("product_id", this.productId)
    formData.append("rating_data", JSON.stringify([{ 'type': 'safety', 'rating': this.safety }, { 'type': 'performance', 'rating': this.performance }, { 'type': 'design', 'rating': this.design }, { 'type': 'comfort', 'rating': this.design }, { 'type': 'overall', 'rating': this.overall }]))
    formData.append("title", this.customerRatingForm.value.titleAndReview)
    formData.append("description", this.customerRatingForm.value.writeReview)
    formData.append("image", this.fileToUpload)
    formData.append("rating_master_id", this.data.overall.rating_master)
    this.sub.add(this.apiService.updateReview(formData).subscribe({
      next: (res: any) => {
        if (res.success) {
          this.isShowThankyouPage = true
        }
        else {
          this.toastrService.warning(res.data.msg);
        }
      }, error: (error) => {
        this.toastrService.warning(error.msg);
      }
    }))
  }

  onRatingSet(rating: number, flag: any): void {
    if (flag == 'overall') {
      this.overall = rating;
    } else if (flag == 'performance') {
      this.performance = rating;
    } else if (flag == 'safety') {
      this.safety = rating;
    } else if (flag == 'comfort') {
      this.comfort = rating;
    } else if (flag == 'design') {
      this.design = rating;
    }
  }

  onSelectImagefile(event: any) {
    if (event.target.files && event.target.files[0]) {
      this.fileToUpload = event.target.files.item(0);
      var size = event.target.files[0].size;
      var AcSize = Math.round(size / 1024);
      var Extension = event.target.files[0].name.substring(
        event.target.files[0].name.lastIndexOf('.') + 1)?.toLowerCase();

      if (Extension == 'PNG' || Extension == 'JPG' || Extension == 'jpg' || Extension == 'png' || Extension == 'webp' || Extension == 'WEBP') {
        const reader = new FileReader();
        if (AcSize < 300) {
          reader.readAsDataURL(event.target.files[0]);
          reader.onload = () => {
            const img = new Image();
            img.src = reader.result as string;
            this.imageURL = img.src
            // img.onload = () => {
            //   const width = img.width;
            //   const height = img.height;
            // }
          }
        }

        else {
          this.imageURL = ''
          this.toastrService.warning('Upload only 300 KB size files!')
        }

      }
      else {
        this.imageURL = ''
        this.toastrService.warning('Only PNG, JPG, WEBP files allowed')
      }
    }
  }

  removeImage() {
    this.fileToUpload = '';
    this.imageURL = '';
  }

}
